module.exports = __webpack_public_path__ + "img/third-0-opened.40f62953.webp";